"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _react = _interopRequireWildcard(require("react"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _Room = _interopRequireDefault(require("@material-ui/icons/Room"));

var _List = _interopRequireDefault(require("@material-ui/core/List"));

var _ListItem = _interopRequireDefault(require("@material-ui/core/ListItem"));

var _ListItemIcon = _interopRequireDefault(require("@material-ui/core/ListItemIcon"));

var _ListItemText = _interopRequireDefault(require("@material-ui/core/ListItemText"));

var _Wapp = require("wapplr-react/dist/common/Wapp");

var _context2 = _interopRequireDefault(require("configurator-studio-arkitekter-components/dist/common/components/App/context"));

var _withMaterial = require("configurator-studio-arkitekter-components/dist/common/components/Template/withMaterial");

var _Logo = _interopRequireWildcard(require("configurator-studio-arkitekter-components/dist/common/components/Logo"));

var _context3 = _interopRequireDefault(require("../Configurator/context"));

var _materialStyle = _interopRequireDefault(require("./materialStyle"));

var _clsx2 = _interopRequireDefault(require("clsx"));

var _Gallery = _interopRequireDefault(require("../Gallery"));

//import getUtils from "wapplr-react/dist/common/Wapp/getUtils";
var style = require("./style_css.js")["default"];

function Home(props) {
  var _data$settings, _data$settings$basic_, _data$settings2, _data$settings2$basic, _data$settings3, _data$settings3$proje, _data$models, _data$models2, _model$steps, _model$steps$options, _data$settings4, _data$settings4$basic, _data$settings4$basic2, _data$settings5, _data$settings5$basic, _data$settings5$basic2, _data$settings6, _data$settings6$proje, _data$settings6$proje2;

  var context = (0, _react.useContext)(_Wapp.WappContext);
  var appContext = (0, _react.useContext)(_context2["default"]);
  var wapp = context.wapp; //const utils = getUtils(context);

  var menus = appContext.menus,
      routes = appContext.routes;
  var materialStyle = props.materialStyle,
      print = props.print;
  var configuratorContext = (0, _react.useContext)(_context3["default"]);
  var data = configuratorContext.data,
      configuration = configuratorContext.configuration,
      translate = configuratorContext.translate;
  wapp.styles.use(style);

  function _onClick2(_x, _x2) {
    return _onClick.apply(this, arguments);
  }

  function _onClick() {
    _onClick = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(e, menu) {
      var _appContext$template;

      var href;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!((_appContext$template = appContext.template) !== null && _appContext$template !== void 0 && _appContext$template.actions)) {
                _context.next = 8;
                break;
              }

              _context.next = 3;
              return appContext.template.actions.scrollTop();

            case 3:
              if (!(!appContext.template.actions.getState().open && !appContext.template.actions.getState().narrow)) {
                _context.next = 8;
                break;
              }

              _context.next = 6;
              return appContext.template.actions.drawerOpen();

            case 6:
              _context.next = 8;
              return new Promise(function (resolve) {
                return setTimeout(resolve, 500);
              });

            case 8:
              href = menu.href;
              wapp.client.history.push((0, _objectSpread2["default"])({
                search: "",
                hash: ""
              }, wapp.client.history.parsePath(href)));
              e.preventDefault();

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return _onClick.apply(this, arguments);
  }

  var projectTitle = translate((_data$settings = data.settings) === null || _data$settings === void 0 ? void 0 : (_data$settings$basic_ = _data$settings.basic_settings) === null || _data$settings$basic_ === void 0 ? void 0 : _data$settings$basic_.name);
  var projectDescription = translate((_data$settings2 = data.settings) === null || _data$settings2 === void 0 ? void 0 : (_data$settings2$basic = _data$settings2.basic_settings) === null || _data$settings2$basic === void 0 ? void 0 : _data$settings2$basic.description);
  var projectAddress = translate((_data$settings3 = data.settings) === null || _data$settings3 === void 0 ? void 0 : (_data$settings3$proje = _data$settings3.project_settings) === null || _data$settings3$proje === void 0 ? void 0 : _data$settings3$proje.project_address);
  var model = configuration !== null && configuration !== void 0 && configuration.selectedModel && (_data$models = data.models) !== null && _data$models !== void 0 && _data$models.length ? data.models.find(function (model) {
    return model.key === configuration.selectedModel;
  }) : null;
  var hideModels = ((_data$models2 = data.models) === null || _data$models2 === void 0 ? void 0 : _data$models2.length) === 1 && model && data.models[0].key === model.key || !data.models || data.models && data.models.length === 0;
  var hideCollections = !model || model && !model.collections || model && model.collections && model.collections.length === 0 || model && model.collections && model.collections.length === 1;
  var stepI = -1;
  var questionI = -1;
  var step = model !== null && model !== void 0 && (_model$steps = model.steps) !== null && _model$steps !== void 0 && _model$steps.length ? model.steps.find(function (step, i) {
    if (i === 0) {
      stepI = i;
      return true;
    }

    return false;
  }) : null;
  var nextQuestion = step && step.options[questionI + 1] ? {
    step: step,
    question: step.options[questionI + 1]
  } : model !== null && model !== void 0 && model.steps && model.steps[stepI + 1] && (_model$steps$options = model.steps[stepI + 1].options) !== null && _model$steps$options !== void 0 && _model$steps$options.length ? {
    step: model.steps[stepI + 1],
    question: model.steps[stepI + 1].options[0]
  } : {};
  var firstStepRoute = model && nextQuestion.step && nextQuestion.question ? routes.modelsRoute + "/" + model.key + "/" + nextQuestion.step.key + "/" + nextQuestion.question.key : routes.summaryRoute;
  var nextRoute = hideModels ? hideCollections ? firstStepRoute : routes.modelsRoute + "/" + model.key + routes.collectionsRoute : routes.modelsRoute;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx2["default"])(materialStyle.home, style.home, (0, _defineProperty2["default"])({}, style.print, print))
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: style.centerContainer
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: style.logoContainer
  }, !((_data$settings4 = data.settings) !== null && _data$settings4 !== void 0 && (_data$settings4$basic = _data$settings4.basic_settings) !== null && _data$settings4$basic !== void 0 && (_data$settings4$basic2 = _data$settings4$basic.home_logo_icon) !== null && _data$settings4$basic2 !== void 0 && _data$settings4$basic2.disable) ? /*#__PURE__*/_react["default"].createElement("div", {
    className: style.logo
  }, /*#__PURE__*/_react["default"].createElement(_Logo["default"], {
    type: "home",
    configuratorContext: configuratorContext
  })) : null, !((_data$settings5 = data.settings) !== null && _data$settings5 !== void 0 && (_data$settings5$basic = _data$settings5.basic_settings) !== null && _data$settings5$basic !== void 0 && (_data$settings5$basic2 = _data$settings5$basic.home_logo_text) !== null && _data$settings5$basic2 !== void 0 && _data$settings5$basic2.disable) ? /*#__PURE__*/_react["default"].createElement("div", {
    className: style.SA
  }, /*#__PURE__*/_react["default"].createElement(_Logo.SA, {
    type: "home",
    configuratorContext: configuratorContext
  })) : null), /*#__PURE__*/_react["default"].createElement("div", {
    className: style.textContainer
  }, projectTitle ? /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    variant: "h5",
    className: style.title
  }, projectTitle) : null, projectDescription ? /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    variant: "body2",
    color: "textSecondary",
    className: style.description
  }, projectDescription) : null, (_data$settings6 = data.settings) !== null && _data$settings6 !== void 0 && (_data$settings6$proje = _data$settings6.project_settings) !== null && _data$settings6$proje !== void 0 && (_data$settings6$proje2 = _data$settings6$proje.gallery) !== null && _data$settings6$proje2 !== void 0 && _data$settings6$proje2.length ? /*#__PURE__*/_react["default"].createElement("div", {
    className: style.gallery
  }, /*#__PURE__*/_react["default"].createElement(_Gallery["default"], {
    gallery: data.settings.project_settings.gallery
  })) : null, projectAddress ? /*#__PURE__*/_react["default"].createElement(_List["default"], {
    className: style.list
  }, /*#__PURE__*/_react["default"].createElement(_ListItem["default"], null, /*#__PURE__*/_react["default"].createElement(_ListItemIcon["default"], {
    className: materialStyle.listItemIcon
  }, /*#__PURE__*/_react["default"].createElement(_Room["default"], null)), /*#__PURE__*/_react["default"].createElement(_ListItemText["default"], {
    primary: projectAddress
  }))) : null), /*#__PURE__*/_react["default"].createElement("div", {
    className: style.buttons
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    onClick: function onClick(e) {
      return _onClick2(e, {
        href: nextRoute
      });
    },
    children: translate(menus.startConfiguratorMenu),
    variant: "contained",
    color: "secondary"
  }))));
}

var WappComponent = (0, _Wapp.withWapp)(Home);
var StyledComponent = (0, _withMaterial.withMaterialStyles)(_materialStyle["default"], WappComponent);
var _default = StyledComponent;
exports["default"] = _default;